/* eslint-disable import/no-anonymous-default-export */
import 'devextreme/dist/css/dx.common.css';
import './themes/generated/theme.base.css';
import './themes/generated/theme.additional.css';
import React, { useEffect } from 'react';
import { useScreenSizeClass } from './utils/media-query';
import UnauthenticatedContent from './UnauthenticatedContent';
import Content from './Content';
import { observer } from 'mobx-react-lite';
//import { AuthStore } from './store';
import  AuthStore  from './main/auth/auth-store';
import { withRouter } from 'react-router';
import { ResetPasswordForm } from './components';

const App = ({ history, location }) => {
   if (process.env.NODE_ENV === "production") {
    console.log = function no_console() {};
    console.warn = function no_console() {};
  }

  //console.log('App Load');

  const screenSizeClass = useScreenSizeClass();
  const { user } = AuthStore;

  useEffect(() => {
    // console.log('App > useEffect()');

    // console.log(user);
    // console.log(sessionStorage.getItem('user'));
    if (!user && user !== sessionStorage.getItem('user')) {
      AuthStore.setUser(JSON.parse(sessionStorage.getItem('user')));
    }
  }, [user]);

  // console.log('pathname : ', location.pathname);

  return (
    <div className={`app ${screenSizeClass}`}>
      {user ? (
        location.pathname === '/reset-password' ? (
          <div className={`app-login ${screenSizeClass}`}>
            <ResetPasswordForm />
          </div>
        ) : (
          <Content />
        )
      ) : (
        <div className={`app-login ${screenSizeClass}`}>
          <UnauthenticatedContent />
        </div>
      )}
    </div>
  );
};

export default withRouter(observer(App));
